import React from 'react';
//import { GoogleLogin } from 'react-google-login-component'

class Google extends React.Component {

  render() {
    return (
      <div>
        Login<br/>
        Logout<br/>
        GetContacts<br/>
      </div>
    );
  }
}

export default Google;



// WEBPACK FOOTER //
// ./src/containers/Google.js